import NavBar from "../../components/NavBar/NavBar";
import { brandLogos, contactEmail, getAccessToken, setAccessToken } from "../../brand";
import "./CompleteSignUpPage.scss";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axiosClient from "../../axiosClient";
import { UPGRADE_MODAL_URL } from "../../lib/upgradeModal";

/**
 * Stripe redirect return URL for signup.
 * Confirms payment with the backend and only then issues access tokens.
 */
export default function CompleteSignUpPage() {
  const [searchParams] = useSearchParams();
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [isCompleting, setIsCompleting] = useState(true);

  // Logged-in users paying from the upgrade modal return here with upgrade=1 and keep their existing session.
  const isUpgrade = searchParams.get("upgrade") === "1";
  const checkoutPath = isUpgrade ? UPGRADE_MODAL_URL : "/sign-up";

  useEffect(() => {
    const paymentIntentId = searchParams.get("payment_intent");
    const setupIntentId = searchParams.get("setup_intent");
    const redirectStatus = searchParams.get("redirect_status");

    if (!paymentIntentId && !setupIntentId) {
      window.location.replace(checkoutPath);
      return;
    }

    if (redirectStatus && redirectStatus !== "succeeded") {
      setIsCompleting(false);
      setErrorMessage(
        `Payment was not completed. Please try again or contact ${contactEmail} for support.`,
      );
      return;
    }

    const complete = async () => {
      try {
        const body: { paymentIntentId?: string; setupIntentId?: string } = {};
        if (paymentIntentId) body.paymentIntentId = paymentIntentId;
        if (setupIntentId) body.setupIntentId = setupIntentId;

        const response = await axiosClient.post(
          "/payments/oq-complete-subscription",
          body,
        );
        const { accessToken } = response.data;
        if (accessToken) {
          setAccessToken(accessToken);
          window.location.replace("/dashboard");
          return;
        }
        if (getAccessToken()) {
          window.location.replace("/dashboard");
          return;
        }
        window.location.replace(
          `${process.env.REACT_APP_SITE_URL}/login`,
        );
      } catch (err: any) {
        console.error(err);
        setIsCompleting(false);
        setErrorMessage(
          err?.response?.data?.error ||
            `Could not finish ${isUpgrade ? "your purchase" : "signup"}. Please contact ${contactEmail} for support.`,
        );
      }
    };

    complete();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  return (
    <>
      <NavBar />
      <div id="CompleteSignUpPage">
        <div className="site-container">
          <div className="order-summary-wrapper">
            <div className="order-summary-inner">
              <div className="big-logo-wrapper">
                <img src={brandLogos.png} className="big-logo" alt="" />
              </div>

              <div className="inner-wrapper">
                {isCompleting && !errorMessage && (
                  <>
                    <h1>Confirming payment…</h1>
                    <p>
                      {isUpgrade
                        ? "Please wait while we unlock your question banks."
                        : "Please wait while we finish setting up your account."}
                    </p>
                  </>
                )}
                {errorMessage && (
                  <>
                    <h1>{isUpgrade ? "Purchase incomplete" : "Signup incomplete"}</h1>
                    <p style={{ color: "red" }}>{errorMessage}</p>
                    <p>
                      <a href={checkoutPath}>{isUpgrade ? "Return to checkout" : "Return to signup"}</a>
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
